var ADDON_ID="storybook/measure-addon",TOOL_ID=`${ADDON_ID}/tool`,PARAM_KEY="measureEnabled";

export { ADDON_ID, PARAM_KEY, TOOL_ID };
